import {
    Building2,
    CalendarDays,
    ChevronDown,
    Download,
    Eye,
    Plus,
    Bell,
    Network,
  } from "lucide-react";
  
  const OrganizationHeader = () => {
    return (
      <header className="w-full border-b border-slate-200 bg-white">
        <div className="px-6 py-5">
  
          {/* Header Top */}
          <div className="flex flex-col gap-5 xl:flex-row xl:items-start xl:justify-between">
  
            {/* Title */}
            <div className="flex items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-theme-50 text-primary">
                <Network size={22} strokeWidth={2} />
              </div>
  
              <div>
                <h1 className="text-[22px] font-semibold leading-7 text-slate-800">
                  Organization Structure Dashboard
                </h1>
  
                <p className="mt-1 text-sm text-slate-500">
                  Welcome back, John!
                </p>
              </div>
            </div>
  
            {/* Organization / Date / Notification / User */}
            <div className="flex flex-wrap items-center gap-3">
  
              {/* Organization Selector */}
              <button
                type="button"
                className="flex h-10 items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 text-sm transition hover:border-theme-300 hover:bg-theme-50"
              >
                <Building2
                  size={17}
                  className="text-primary"
                />
  
                <div className="text-left">
                  <p className="text-[11px] leading-3 text-slate-400">
                    Organization
                  </p>
  
                  <p className="mt-0.5 font-medium text-slate-700">
                    AutoAway Technologies Pvt. Ltd.
                  </p>
                </div>
  
                <ChevronDown
                  size={16}
                  className="ml-1 text-slate-400"
                />
              </button>
  
              {/* Date */}
              <div className="hidden items-center gap-2 border-l border-slate-200 pl-3 md:flex">
                <CalendarDays
                  size={17}
                  className="text-slate-400"
                />
  
                <div>
                  <p className="text-[11px] leading-3 text-slate-400">
                    Today
                  </p>
  
                  <p className="mt-0.5 text-xs font-medium text-slate-700">
                    07 Aug 2026
                  </p>
                </div>
              </div>
  
              {/* Notification */}
              <button
                type="button"
                className="relative flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition hover:border-theme-300 hover:bg-theme-50 hover:text-primary"
                aria-label="Notifications"
              >
                <Bell size={18} />
  
                <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" />
              </button>
  
              {/* User */}
              <button
                type="button"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-theme-100 text-sm font-semibold text-primary"
                aria-label="User profile"
              >
                AK
              </button>
            </div>
          </div>
  
          {/* Action Buttons */}
          <div className="mt-5 flex flex-wrap items-center justify-end gap-2">
  
            {/* Add New */}
            <button
              type="button"
              className="inline-flex h-10 items-center gap-2 rounded-lg bg-primary px-4 text-sm font-medium text-white shadow-sm transition hover:bg-primary-dark"
            >
              <Plus size={17} />
              Add New
            </button>
  
            {/* Export */}
            <button
              type="button"
              className="inline-flex h-10 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-600 transition hover:border-theme-300 hover:bg-theme-50 hover:text-primary"
            >
              <Download size={16} />
              Export Structure
            </button>
  
            {/* Reports */}
            <button
              type="button"
              className="inline-flex h-10 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-600 transition hover:border-theme-300 hover:bg-theme-50 hover:text-primary"
            >
              <Eye size={16} />
              View Reports
            </button>
  
          </div>
        </div>
      </header>
    );
  };
  
  export default OrganizationHeader;